export const formatPermissionLabel = (permission: string) => {
  switch (permission) {
    case 'tigertouchplus_reporting':
      return 'Patient Reporting';
    case 'contact_center_operator':
      return 'Operator';
    case 'contact_center_operator_supervisor':
      return 'Operator Supervisor';
    default:
      return permission.replaceAll('_', ' ').replaceAll('scim', 'SCIM');
  }
};
